// Define the steps for the Send to Entrata process
export enum Step {
  SELECT_MATCHING_ROUND = 1,
  EXPORT_SUMMARY = 1.7, // Step for viewing individual export details
  REVIEW = 2,
  CONFIRM_EXPORT = 3,
  EXPORT_LOG = 4,
}

export interface MatchingRound {
  id: number;
  name: string;
  status: string;
  date: string;
  hasExports?: boolean;
}

export interface PreviousExport {
  id: number;
  runId: string; // Added to support CSV download
  matchingRoundName: string;
  date: string;
  exportDate: string;
  exportTime: string;
  successfulGroups: number;
  unsuccessfulGroups: number;
  singleResidents: number;
  status: string;
}

export interface ArchivedExport {
  id: number;
  matchingRoundName: string;
  date: string;
  time: string;
  groupsExported: number;
  residentsExported: number;
}

export interface GroupStatistics {
  fullGroups: number;
  partialGroups: number;
  singleResidents: number;
}
